import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { LoaderComponent } from 'src/app/pages/common/loader';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { GlobalContants } from 'src/app/constants/global.contants';


@Component({
  selector: 'app-avm-calculator-form',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, FormsModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './avm-calculator-form.component.html',
  styles: [`mat-select { border: 1px solid #ccc !important; padding: 2px !important; }
  `]
})
export class AvmCalculatorFormComponent implements OnInit {
  @Input() apiBaseUrl: string = '';

  selected_view = 'Params';
  api_end_point = '';
  loader = false;
  response: any;

  api_Response:any;
  is_requested = false;
  form: FormGroup;
  api_key = '';
  user_token = '';
  city_code = ''; 

  // Hardcoded options from provided data (labels)
  houseTypeOptions = [
    { value: 'government', label: 'Government' },
    { value: 'middle_income', label: 'Middle Income' },
    { value: 'standard', label: 'Standard' },
    { value: 'limited_income', label: 'Limited Income' }
  ];

  floorOptions = [
    { value: '0', label: 'G' },
    { value: '1', label: 'G + 1' },
    { value: '1.5', label: 'G + 1.5' },
    { value: '2', label: 'G + 2' },
    { value: '2.5', label: 'G + 2.5' },
    { value: '3', label: 'G + 3' }
  ];

  basementOptions = [
    { value: 'no_basement', label: 'No Basement' },
    { value: 'half_basement', label: 'Half Basement' },
    { value: 'full_basement', label: 'Full Basement' }
  ];

  buildingAgeOptions = [
    { value: '1_to_5', label: '1 to 5' },
    { value: '6_to_10', label: '6 to 10' },
    { value: '11_to_15', label: '11 to 15' },
    { value: '16_to_20', label: '16 to 20' },
    { value: 'more_than_20', label: 'More than 20' }
  ];

  finishQualityOptions = [
    { value: 'super_luxury', label: 'Super Luxury' },
    { value: 'luxury', label: 'Luxury' },
    { value: 'delux', label: 'Delux' },
    { value: 'standard', label: 'Standard' }
  ];

  basementUsesOptions = [
    { value: 'parking', label: 'Parking' },
    { value: 'living', label: 'Living' },
    { value: 'mixed', label: 'Mixed' }
  ];

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private userService: UserService,
    private alertService: AlertService,
    private apiService: ApiService
  ) {
    this.form = this.fb.group({
      land_area: [''],
      property_uid: [''],
      block_uid: [''],
      built_area: [''],
      floor: ['1'],
      neigh_uid:[''],
      basement: ['no_basement'],
      building_age: ['6_to_10'],
      finish_quality: ['standard'],
      basement_uses: [{value: '', disabled:true}],
      shaded_parking: [''],
      type:['standard']
    });
  }

  ngOnInit(): void {
    this.getAPIKey();
    this.getToken();
    this.onChange(); // Initial URL
  }

  changeSelection(value: string) {
    this.selected_view = value;
  }

  onBasementChange(value: string) {
    if (value === 'no_basement') {
      this.form.patchValue({ basement_uses: '' });
      this.form.get('basement_uses')?.disable();
    } else {
      this.form.get('basement_uses')?.enable();
    }
    this.onChange();
  }

  onChange() {
    let payload: any = { ...this.form.value };
    payload.shaded_parking = payload.shaded_parking;
    if (payload.floor === '') payload.floor = 2;
    const params = Object.entries(payload)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '' && value !== '0')
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    this.api_end_point = `${this.apiBaseUrl}?${params}`;
  }

  onSubmit() {
    if (this.loader) return;
   
    if(!this.city_code?.trim()) {
      this.alertService.warning("City Code is required");
      return;
    }
    
     if (!this.form.value.property_uid) {
      this.alertService.warning("Property UID is required");
      return;
    }
    let payload: any = { ...this.form.value };
    payload.shaded_parking = payload.shaded_parking;
    if (payload.floor === '') payload.floor = 2;
    const params = Object.entries(payload)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '' && value !== '0')
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    let apiEndPoint = `${this.apiBaseUrl}?${params}`;
    this.loader = true;
    this.apiService.getAVMRental(apiEndPoint, this.api_key, this.user_token, this.city_code).subscribe({
      next: (res: any) => {
        this.is_requested = true;
        this.loader = false;
        this.selected_view = 'Response';
        if (res && res.status === 200) {
          const data = res.data;
          this.api_Response = {...data};
          this.response = data;         
          this.response['total'] ={
            sale_price_min : (data.land_price.sale_price_min + data.properties_price.sale_price_min),
            sale_price_max : (data.land_price.sale_price_max + data.properties_price.sale_price_max)
          }
        } else {
          this.response = null;
          this.api_Response = null;
          if(res.status === 500){
            this.alertService.error('Internal server error');
          }else{
            this.alertService.error(res?.message);
          }
        }
      },
      error: (error: any) => {
        this.api_Response = null;
        this.selected_view = 'Response';
        this.is_requested = true;
        this.loader = false;
        this.response = null;
        this.alertService.error(error.error?.message || 'Internal server error');
      }
    });
  }

  getAPIKey() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    let company_id = userInfo?.company_details?.company_id;
    this.userService.getAPIKey(Number(company_id)).subscribe({
      next: (res: any) => {
        if (res.status === 200 && res.data[0]) {
          this.api_key = res.data[0].api_key;
        } else {
          this.api_key = '';
        }
      },
      error: (err) => {
        this.api_key = '';
      }
    });
  }

  getToken() {
    let token = this.sharedService.getStoreValue(GlobalContants.StoreKey.userToken);
    let body = { token, is_refresh: false };
    this.userService.updateToken(body).subscribe({
      next: (res: any) => {
        if (res.status === 201) {
          this.user_token = res.data;
        } else {
          this.user_token = '';
        }
      },
      error: (err) => {
        this.user_token = '';
        this.alertService.error(err.error?.message);
      }
    });
  }
}